import NamedDto from 'modules/base/dto/NamedDto';

export class ModelValidationStateInjectEditDto extends NamedDto {
	constructor() {
		super();

		/** @type {number} */
		this.type = null;

		/** @type {string} */
		this.value = null;
	}

	/**
	 * @typedef {Object} _ModelValidationStateInjectEditDtoProps
	 * @property {number} type
	 * @property {string} value
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _ModelValidationStateInjectEditDtoProps} ModelValidationStateInjectEditDtoProps
	 */
	/**
	 *
	 * @param {ModelValidationStateInjectEditDtoProps} props
	 * @returns {ModelValidationStateInjectEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.type = props.type;
		this.value = props.value;

		return this;
	}
}

export default ModelValidationStateInjectEditDto;